import FieldsDataTable from "../../../components/dataTable/tables/field/FieldsDataTable";

function FieldsPageView() {
  return <FieldsDataTable />;
}

export default FieldsPageView;
